<template><div><h1 id="spenderliste" tabindex="-1"><a class="header-anchor" href="#spenderliste"><span>Spenderliste</span></a></h1>
<p>Spenderliste — Liste der Spender von Anlassspenden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden die Spender zu einer <RouteLink to="/manual/customer/anlassspenden.html" title="2. Anlassspenden">Anlassspende</RouteLink> angezeigt.</p>
<p>Pfad: <code v-pre>Personen → Anlassspenden → Anlassspenden</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Personen-ID</dt>
<dd>Personen-ID des Spenders.</dd>
<dt>Name und Adresse</dt>
<dd>Name und Adresse des Spenders.</dd>
<dt>Datum</dt>
<dd>Datum der Spende.</dd>
<dt>Betrag</dt>
<dd>Responsewert der Spende.</dd>
<dt>V</dt>
<dd>Zeigt an, ob die Spende verdankt, nicht verdankt oder ausgeschlossen wurde. Leer = noch nicht verarbeitet, V = verdankt, N = nicht verdankt, A = manuell aus dem Verdankungslauf ausgeschlossen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="spenderliste-1" tabindex="-1"><a class="header-anchor" href="#spenderliste-1"><span>Spenderliste</span></a></h3>
<p>Druckt eine Liste der Spender, wahlweise mit/ohne Betrag oder mit/ohne Detailanzeige der Adresse.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/anlassspenden.html" title="2. Anlassspenden">Anlassspenden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.anlass.html" title="Anlass">Anlass</RouteLink></p>
</div></template>


